import { render, staticRenderFns } from "./ChatList.vue?vue&type=template&id=37e8d028&scoped=true"
import script from "./ChatList.vue?vue&type=script&lang=js"
export * from "./ChatList.vue?vue&type=script&lang=js"
import style0 from "./ChatList.vue?vue&type=style&index=0&id=37e8d028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e8d028",
  null
  
)

export default component.exports